"use client"

import styled from "@emotion/styled"
import Image from "next/image"
import { useInView } from "react-intersection-observer"
import "swiper/css"
import Container from "ui/Container"
import { useInViewConfig } from "ui/transitions/utils"
import { HistoryData, versionedAsset } from "utils"
import TimelineItem from "./TimelineItems"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  position: relative;
  margin: 32px 0;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 88px;
    margin: 88px 0;
    margin-top: 168px;
  }
`

const TimelineLine = styled.div`
  position: absolute !important;
  width: 2px;
  height: 100%;
  left: 0;
  top: 0;
  background-image: url("/images/historyPageLine.png");
  background-repeat: repeat-y;
  background-size: 2px 720px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    background-image: url("/images/historyMobileLine.png");
    left: 50%;
    transform: translateX(-50%);
  }
`

const MobileBusWrapper = styled.div<{ inView: boolean }>`
  display: none;
  ${({ theme }) => theme.breakpoints.up("md")} {
    display: block;
  }
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transition:
    top 8s ease,
    opacity 0.1s ease 6s;
  top: ${({ inView }) => (inView ? "100%" : "0")};
  opacity: ${({ inView }) => (inView ? 0 : 1)};
  z-index: 2;
  width: 32px;
  height: 32px;
`

type Props = {
  data: HistoryData[]
}

const HistoryTimeLine: React.FC<Props> = ({ data }) => {
  const { inView, ref } = useInView({ ...useInViewConfig, threshold: 0 })
  return (
    <Container paddingMobile={true}>
      <StyledLayout ref={ref}>
        <TimelineLine />
        <MobileBusWrapper inView={inView}>
          <Image
            src={versionedAsset("/images/busHistoryMobile.png")}
            alt="History Timeline Bus"
            width={32}
            height={120}
          />
        </MobileBusWrapper>
        {data.map((item, i) => (
          <TimelineItem el={item} index={i} key={item.title} />
        ))}
      </StyledLayout>
    </Container>
  )
}

export default HistoryTimeLine
